import React from "react";
import Layout from "../components/Layout";

export default function Terms() {
    return (
        <Layout title="Terms of Use">
            <section>
                <h1>Terms of Use</h1>

                <p>
                    By accessing or using the Lil Rockstars Racing website, you agree to
                    comply with these Terms of Use.
                </p>

                <h2>Use of the Site</h2>
                <p>
                    This website is intended for parents, guardians, and participants of
                    Lil Rockstars Racing. You agree not to misuse the site or interfere
                    with its operation.
                </p>

                <h2>Accounts</h2>
                <p>
                    You are responsible for maintaining the confidentiality of your
                    account credentials and for all activity that occurs under your
                    account.
                </p>

                <h2>Content</h2>
                <p>
                    All content on this site is provided for informational and
                    organizational purposes. Unauthorized reproduction is prohibited.
                </p>

                <h2>Limitation of Liability</h2>
                <p>
                    Lil Rockstars Racing is not liable for any damages arising from the use
                    of this website or participation in events, except as required by law.
                </p>

                <h2>Changes</h2>
                <p>
                    We may update these Terms of Use at any time. Continued use of the site
                    constitutes acceptance of the updated terms.
                </p>
            </section>
        </Layout>
    );
}